import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgVideoAttachment = (props) => /* @__PURE__ */ _jsxs("svg", {
	width: 24,
	height: 24,
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: [/* @__PURE__ */ _jsxs("g", {
		clipPath: "url(#clip0_7418_15636)",
		children: [/* @__PURE__ */ _jsx("path", {
			fillRule: "evenodd",
			clipRule: "evenodd",
			d: "M0 4.8C0 2.14903 2.14903 0 4.8 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L23.2971 5.29706C23.7471 5.74714 24 6.35759 24 6.99411V19.2C24 21.851 21.851 24 19.2 24H4.8C2.14903 24 0 21.851 0 19.2V4.8ZM10.3885 16.9411L15.688 13.4081C15.7223 13.3852 15.7503 13.3543 15.7697 13.318C15.7892 13.2817 15.7993 13.2412 15.7993 13.2001C15.7993 13.1589 15.7892 13.1184 15.7697 13.0821C15.7503 13.0458 15.7223 13.0149 15.688 12.9921L10.3885 9.45906C10.3509 9.43401 10.3071 9.41963 10.262 9.41747C10.2168 9.41531 10.1719 9.42544 10.132 9.44679C10.0921 9.46813 10.0588 9.49989 10.0356 9.53868C10.0123 9.57747 10 9.62184 10 9.66706V16.7331C10 16.7783 10.0123 16.8226 10.0356 16.8614C10.0588 16.9002 10.0921 16.932 10.132 16.9533C10.1719 16.9747 10.2168 16.9848 10.262 16.9826C10.3071 16.9805 10.3509 16.9661 10.3885 16.9411Z",
			fill: "#4F49BA"
		}), /* @__PURE__ */ _jsx("path", {
			d: "M16.5 0H17.0059C17.6424 0 18.2529 0.252856 18.7029 0.702944L24 6H18.9C17.5745 6 16.5 4.92548 16.5 3.6V0Z",
			fill: "white",
			fillOpacity: .16
		})]
	}), /* @__PURE__ */ _jsx("defs", { children: /* @__PURE__ */ _jsx("clipPath", {
		id: "clip0_7418_15636",
		children: /* @__PURE__ */ _jsx("rect", {
			width: 24,
			height: 24,
			fill: "white"
		})
	}) })]
});
export default SvgVideoAttachment;
